import { z } from 'zod'
import { idSchema, isoDateTimeSchema, text } from './common.js'

/**
 * A workshop-defined grouping of workers — "Bodywork", "Mechanical",
 * "Reception", whatever the garage actually organises itself into. There is
 * no fixed list: a department only exists because someone created it here.
 */
const departmentFields = {
  name: text(80),
}

export const departmentInputSchema = z.object(departmentFields)
export type DepartmentInput = z.infer<typeof departmentInputSchema>

export const departmentSchema = z.object({
  ...departmentFields,
  id: idSchema,
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
})
export type Department = z.infer<typeof departmentSchema>

export interface DepartmentWithCount extends Department {
  /** Active (non-deleted) workers currently assigned to it. */
  workerCount: number
}
